interface KommerSnartProps {
  description?: string
}

export function KommerSnart({ description }: KommerSnartProps) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '64px 24px', color: '#94a3b8', textAlign: 'center',
    }}>
      <div style={{ fontSize: 14, fontWeight: 600, color: '#64748b', marginBottom: 6 }}>
        Kommer snart
      </div>
      {description && (
        <div style={{ fontSize: 13, maxWidth: 320 }}>{description}</div>
      )}
    </div>
  )
}
